import { clearDefaultSessionTokenHeader } from "../../componentes-padrao/AxiosConfig";
import { api } from "../../modules/Axios/api";
import { EmpesaLogadaPayload } from "./types";

export const login = async (code: string) => {
    return await api.post("auth/login", { code: code });
};

export const setEmpresa = async (payload: EmpesaLogadaPayload) => {
    return await api.post("auth/set-selected-company", {
        company_id: payload.empresaID,
        branch_ids: payload.filialIDs,
    });
};

export const refreshToken = async (refreshToken: string) => {
    const { data } = await api.post("auth/refresh", {
        refresh_token: refreshToken,
    });
    return data;
};

export const logout = async (refreshToken: string) => {
    const { data } = await api.post("auth/logout", {
        refresh_token: refreshToken,
    });

    clearDefaultSessionTokenHeader();
    return data;
};

export const getCompaniesAllowed = async () => {
    const { data } = await api.get("auth/companies-allowed");

    return data;
};

export const getBranchesAllowed = async (selectedCompanyId: number) => {
    const { data } = await api.get("auth/branches-allowed", {
        params: {
            company_id: selectedCompanyId,
        },
    });

    return data;
};

export const getAllowedMenus = async () => {
    const { data } = await api.get("auth/menus-allowed");

    return data;
};

export const getScreenAllowedActions = async (screenGridClass: string) => {
    const { data } = await api.get("auth/screen-allowed-actions", {
        params: {
            screen_grid_class: screenGridClass,
        },
    });

    return data;
};
